
/**
 *      Data-driven UI logic for search suggestions
 *
 *      @author: Irina Patrikeeva <irina.i.patrikeeva@nasa.gov>
 *
 *      Created on 12/05/2017
 *      Modified on 12/04/2019
 */


/**
 * Show search term suggestions below the search bar
 * @param data {JSON} - suggestion words
 */
function showTypeahead( data ) {

    if ( typeof Bloodhound !== "undefined" ) {
        var suggestions = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.whitespace,
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                local: data
            }),
            headerParentId = App.globalState.headerParentId,
            searchBarId = '#edi-search-bar',
            searchBar = $( '#' + headerParentId ).find( searchBarId );

        if ( searchBar && searchBar.length > 0 ) {
            if ( typeof Typeahead !== "undefined" ) {
                $( searchBarId + ' .typeahead' ).typeahead(
                    {
                        hint: false,
                        highlight: true,
                        minLength: 3
                    },
                    {
                        name: 'suggestions',
                        source: suggestions
                    }
                );
            }
        }
    }
}

/***
 * Setup autocomplete
 * @param query {string} - search query
 */
/*global Bloodhound */
function autocomplete( query ) {
    var url =  App.globalState.searchAPIBase + '/suggest?q=' + encodeURIComponent(query),
        alias,
        data = {};


    alias = App.globalState.alias;

    if ( alias ) {
        data.alias = alias;
    }

    // Cleanup the previous request and make the new request
    if ( this.existingRequest ) {
        this.existingRequest.abort();
    }
    this.existingRequest = $.ajax({
        url: url,
        data: data,
        dataType: 'json'
    })
    .done(function (response) {

        var typeahead = $( '.typeahead' );
        if ( typeahead ) {

            if ( typeof Typeahead !== "undefined" ) {
                typeahead.typeahead( 'destroy' );
            }

            showTypeahead( response );
            typeahead.focus();
        }
    })
    .fail(function (jqXHR) {

        if (console && console.log) {
            console.log('Failed to fetch suggestions for query ' + query);
        }
    });
}
